// index.tsx
import { Skeleton } from '@components'
import { useQuery } from '@tanstack/solid-query'
import { User, UserCircle } from 'lucide-solid'
import { Show } from 'solid-js'
import { Circle, Grid } from 'styled-system/jsx'
import type { CircleProperties } from 'styled-system/patterns'
import { avatarQueryOpts } from './fetchImageUrl'

type AvatarProps = {
  id?: string
  size?: CircleProperties['size']
}

export function Avatar(props: AvatarProps) {
  const q = useQuery(() => avatarQueryOpts(props.id))

  return (
    <Skeleton isLoaded={!q.isLoading}>
      <Show
        when={q.data}
        fallback={
          <Grid height="100%" justifyContent="center" alignItems="center">
            <Circle
              height={props.size || 10}
              width={props.size || 10}
              border="solid 1px"
              borderColor="fg.subtle"
              backgroundSize="cover"
              backgroundPosition="center center"
              style={{ 'background-image': `url(${q.data!})` }}
            >
              <User stroke-width='1px' />
            </Circle>
          </Grid>
        }
      >
        <Circle
          height={props.size || 10}
          width={props.size || 10}
          border="solid 1px"
          borderColor="fg.subtle"
          backgroundSize="cover"
          backgroundPosition="center center"
          style={{ 'background-image': `url(${q.data!})` }}
        />
      </Show>
    </Skeleton>
  )
}
